import { useTranslation } from 'react-i18next';
import { GoalSummaryCard } from './GoalSummaryCard';
import type { EmployeePopulatedGoalIssue } from '@momentum/types';

interface GoalsSummarySwiperProps {
  goals: EmployeePopulatedGoalIssue[];
}

export const GoalsSummarySwiper = ({ goals }: GoalsSummarySwiperProps) => {
  const { t } = useTranslation('oneOnOne');

  if (goals.length === 0) {
    return (
      <div className="rounded-lg border border-slate-200 bg-slate-50 p-8 text-center">
        <p className="text-muted-foreground">{t('noGoalsToReview')}</p>
      </div>
    );
  }

  return (
    <div className="max-h-[600px] space-y-3 overflow-y-auto pe-2">
      {goals.map((goal) => (
        <GoalSummaryCard key={goal._id} goal={goal} />
      ))}
    </div>
  );
};
